/* eslint-disable max-len */
import images from 'assets/images';
import Breadcrumb from 'components/App/Breadcrumb';
import Button from 'components/App/Button';
import DataTableDiscovery from 'components/App/DataTableDiscovery';
import AppInputValidation from 'components/App/InputValidation';
import Meta from 'components/App/Meta';
import AppSelectValidation from 'components/App/SelectValidation';
import ModalRequestAction from 'components/Modals/ModalRequestAction';
import Pagination from 'components/Pagination';
import { themeColor } from 'constants/index';
import { useFormik } from 'formik';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Card,
  Col,
  Container,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  actionCleanupDiscoveryCategories as actionCleanupDiscoveryCategoriesAction, actionGetDiscoveryCategories as actionGetDiscoveryCategoriesAction,
} from 'store/actions';
import {
  actionCleanupDiscoverPlaceList as actionCleanupDiscoverPlaceListAction,
  actionDeleteDiscoverPlace as actionDeleteDiscoverPlaceAction,
  actionGetDiscoverPlaceList as actionGetDiscoverPlaceListAction,
} from 'store/discover-place/actions';
import {
  actionCleanupDiscoveryProvinces as actionCleanupDiscoveryProvincesAction,
  actionGetDiscoveryProvinces as actionGetDiscoveryProvincesAction,
} from 'store/discover-province/actions';
import { useBoolean } from 'usehooks-ts';
import { filterAllValueObject, getParamsFormObject, showSuccess } from 'utils';
import cn from 'utils/classnames';
import Loading from 'components/App/Loading';
import ENDPOINT from 'constants/endPoint';
import styles from './DiscoveryLocation.module.scss';

const TAB = {
  ALL: 'ALL',
  ACTIVE: 'true',
  DELETED: 'false',
};

const NAV_TAB = [
  { title: 'Tất cả', value: TAB.ALL },
  { title: 'Đang hoạt động', value: TAB.ACTIVE },
  { title: 'Đã xoá', value: TAB.DELETED },
];

const DEFAULT_LIMIT = 20;

const BREADCRUMB_LIST = [
  {
    name: 'Khám phá',
    isActive: false,
    link: '', // TODO: ADD ROUTE WHEN HAVE LINK
  },
  {
    name: 'Danh sách điểm khám phá',
    isActive: true,
    link: '', // TODO: ADD ROUTE WHEN HAVE LINK
  },
];

function DiscoveryLocation({
  // Discover Place
  discoverPlaceList,
  discoverPlaceListLoading,
  actionGetDiscoverPlaceList,
  actionCleanupDiscoverPlaceList,

  // Discover Province
  provincesLoading,
  provinces,
  actionGetDiscoveryProvinces,
  actionCleanupDiscoveryProvinces,

  // Discover Category
  categoriesLoading,
  categories,
  actionGetDiscoveryCategories,
  actionCleanupDiscoveryCategories,

  // Delete Discover Place
  deleteLoading,
  actionDeleteDiscoverPlace,
}) {
  const tableData = React.useMemo(() => discoverPlaceList?.data ?? [], [discoverPlaceList]);
  const tableTotal = React.useMemo(() => discoverPlaceList?.total ?? 0, [discoverPlaceList]);
  const tableLoading = React.useMemo(() => discoverPlaceListLoading, [discoverPlaceListLoading]);
  const totalPage = React.useMemo(() => Math.ceil(tableTotal / DEFAULT_LIMIT), [tableTotal]);

  const history = useHistory();

  const params = useMemo(() => new URLSearchParams(history.location.search),
    [history.location.search]);

  const searchQueries = useMemo(() => ({
    page: params.get('page') || 1,
    q: params.get('q') || '',
    category: params.get('category') || '',
    limit: DEFAULT_LIMIT,
    province: params.get('province') || '',
    isPublished: params.get('isPublished') || TAB.ALL,
  }), [params]);

  const [detail, setDetail] = React.useState(null);

  const validation = useFormik({
    initialValues: {
      q: searchQueries.q,
      province: searchQueries.province,
      category: searchQueries.category,
      isPublished: searchQueries.isPublished,
      page: searchQueries.page,
      limit: DEFAULT_LIMIT,
    },
    onSubmit: (values) => {
      history.push({
        search: getParamsFormObject({
          ...values,
          page: 1,
        }),
      });
    },
  });

  const isSearchBtnDisabled = React.useMemo(() => (
    Object
      .values(omit(validation.values, ['limit', 'page']))
      .filter(Boolean)
      .length === 0
    && validation.values.q === ''
  ), [validation.values]);

  const {
    value: isOpenModalDeleteLocation,
    setTrue: onOpenModalDeleteLocation,
    setFalse: onCloseModalDeleteLocation,
    toggle: onToggleModalDeleteLocation,
  } = useBoolean(false);

  const onChangeFilterOption = React.useCallback((e) => {
    validation.setFieldValue(e.name, e.value, true);
  }, [validation]);

  const onResetForm = React.useCallback(() => {
    const formValue = {
      q: '',
      province: '',
      category: '',
      isPublished: TAB.ALL,
      page: 1,
      limit: DEFAULT_LIMIT,
    };

    validation.setValues(formValue);

    history.push({
      search: getParamsFormObject({ ...formValue }),
    });
  }, [history, validation]);

  const onChangeTab = React.useCallback((tab) => () => {
    validation.setFieldValue('isPublished', tab, true);

    history.push({
      search: getParamsFormObject({
        ...searchQueries,
        isPublished: tab,
        page: 1,
      }),
    });
  }, [history, searchQueries, validation]);

  const onDeleteDiscovery = React.useCallback((itemId, item) => {
    setDetail(item);
    onOpenModalDeleteLocation();
  }, [onOpenModalDeleteLocation]);

  const onAddDiscovery = React.useCallback(() => {
    history.push(ENDPOINT.MANAGER_DISCOVERY_PLACE_CREATE);
  }, [history]);

  const onViewDiscoveryDetail = React.useCallback((id) => {
    history.push(ENDPOINT.MANAGER_DISCOVERY_PLACE_DETAIL(id));
  }, [history]);

  const onChangePage = React.useCallback((selected) => {
    history.push({
      search: getParamsFormObject({
        ...searchQueries,
        page: selected.selected + 1,
      }),
    });
    // tableRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [history, searchQueries]);

  const onConfirmDeleteLocation = React.useCallback(() => {
    actionDeleteDiscoverPlace({
      id: detail._id,
      callback: () => {
        onCloseModalDeleteLocation();
        setDetail(null);
        showSuccess('Xóa điểm khám phá thành công');
      },
    });
  }, [
    actionDeleteDiscoverPlace,
    detail?._id,
    onCloseModalDeleteLocation,
  ]);

  useEffect(() => {
    actionGetDiscoverPlaceList(
      filterAllValueObject({
        page: searchQueries.page,
        limit: DEFAULT_LIMIT,
        q: searchQueries.q,
        discoverProvince: searchQueries.province,
        discoverCategories: searchQueries.category,
        isPublished: searchQueries.isPublished,
      }),
    );
  }, [
    actionGetDiscoverPlaceList,
    searchQueries.category,
    searchQueries.isPublished,
    searchQueries.page,
    searchQueries.province,
    searchQueries.q,
  ]);

  React.useEffect(() => {
    actionGetDiscoveryProvinces({
      page: 1,
      limit: 1000,
    });

    actionGetDiscoveryCategories({
      page: 1,
      limit: 1000,
    });

    return () => {
      actionCleanupDiscoveryProvinces();
      actionCleanupDiscoveryCategories();
      actionCleanupDiscoverPlaceList();
    };
  }, [
    actionCleanupDiscoveryProvinces,
    actionCleanupDiscoveryCategories,
    actionGetDiscoveryCategories,
    actionGetDiscoveryProvinces,
    actionCleanupDiscoverPlaceList,
  ]);

  return (
    <>
      <div className={`page-content ${styles.Page}`}>
        <Meta name="Danh sách chỗ nghỉ" />

        <Container fluid>
          <Breadcrumb
            pageTitle="Danh sách điểm khám phá"
            breadcrumbList={BREADCRUMB_LIST}
          />

          <Loading loading={tableLoading} loaderOnPage />

          <div className="Section">
            <form onSubmit={validation.handleSubmit}>
              <Row>
                <Col xxl="6" className="mb-24">
                  <Label className="Section__Search__Label">
                    Tìm kiếm
                  </Label>

                  <div className="Section__Search__Container">
                    <AppInputValidation
                      name="q"
                      id="q"
                      type="text"
                      placeholder="Tìm theo tên điểm khám phá, số điện thoại liên hệ"
                      validation={validation}
                      inputClassName={cn('Section__Search__Input')}
                    />

                    <i className="fas fa-search Section__Search__Icon__Search" />
                  </div>
                </Col>

                <Col xxl="6">
                  <Label className="Section__Search__Label">
                    Bộ lọc
                  </Label>

                  <Row>
                    <Col xxl="4" lg="6" className="mb-24">
                      <AppSelectValidation
                        placeholder="Điểm đến"
                        name="province"
                        options={provinces.data.map((item) => ({
                          value: item._id,
                          label: item.name,
                        }))}
                        isDisabled={provincesLoading}
                        validation={validation}
                        value={validation.values.province}
                        onChange={onChangeFilterOption}
                        isHiddenSearchable
                        isHiddenClearable
                        isClearable
                        style={{ height: '39px' }}
                      />
                    </Col>

                    <Col xxl="4" lg="6" className="mb-24">
                      <AppSelectValidation
                        placeholder="Hạng mục"
                        name="category"
                        options={categories.data.map((item) => ({
                          value: item._id,
                          label: item.name,
                        }))}
                        isDisabled={categoriesLoading}
                        validation={validation}
                        value={validation.values.category}
                        onChange={onChangeFilterOption}
                        isHiddenSearchable
                        isHiddenClearable
                        isClearable
                        style={{ height: '39px' }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className="d-flex">
                <Button
                  outline
                  classes="Section__Search__Button__ReType mr-24"
                  color={themeColor.LIGHT}
                  onClick={onResetForm}
                >
                  Nhập lại
                </Button>

                <Button
                  classes="Section__Search__Button__Search"
                  type="submit"
                  disabled={isSearchBtnDisabled}
                >
                  Tìm kiếm
                </Button>
              </div>
            </form>
          </div>

          <Card className="Section mt-4">
            <div className="d-flex flex-column flex-md-row gap-4 justify-content-between custom_pills">
              <Nav pills>
                {NAV_TAB.map((tab) => (
                  <NavItem key={tab.value} className="col-md-2">
                    <NavLink
                      className={validation.values.isPublished === tab.value
                        ? 'active'
                        : ''
                      }
                      onClick={onChangeTab(tab.value)}
                    >
                      <span>{tab.title}</span>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <Button
                classes="Table__Header__Button"
                fontSize="13px"
                onClick={onAddDiscovery}
              >
                <i className="fas fa-plus" />
                Thêm điểm khám phá
              </Button>
            </div>

            <TabContent
              activeTab={validation.values.isPublished}
              className="Table__Body"
            >
              <Label className="Table__Body__Total">
                {`${tableTotal.toLocaleString('vi-VN')} điểm khám phá`}
              </Label>

              {NAV_TAB.map((item) => (
                <TabPane
                  tabId={item.value}
                  key={item.value}
                >
                  <DataTableDiscovery
                    isLoadingDiscoveryList={false}
                    discoveries={tableData}
                    onDeleteDiscovery={onDeleteDiscovery}
                    onViewDiscoveryDetail={onViewDiscoveryDetail}
                  />
                </TabPane>
              ))}
            </TabContent>
          </Card>

          <Pagination
            page={searchQueries.page}
            pageCount={totalPage}
            onChangePage={onChangePage}
          />
        </Container>
      </div>

      <ModalRequestAction
        isOpen={isOpenModalDeleteLocation}
        icon={images.modalGarbageCan.default}
        textRequest={'Bạn có chắc chắn muốn xóa \n điểm khám phá này không?'}
        onToggle={onToggleModalDeleteLocation}
        onCloseModal={onCloseModalDeleteLocation}
        onConfirm={onConfirmDeleteLocation}
        isLoadingConfirm={deleteLoading}
      />
    </>
  );
}

DiscoveryLocation.propTypes = {
  discoverPlaceList: PropTypes.instanceOf(Object).isRequired,
  discoverPlaceListLoading: PropTypes.bool.isRequired,
  actionGetDiscoverPlaceList: PropTypes.func.isRequired,
  actionCleanupDiscoverPlaceList: PropTypes.func.isRequired,

  provincesLoading: PropTypes.bool.isRequired,
  provinces: PropTypes.instanceOf(Array).isRequired,
  actionGetDiscoveryProvinces: PropTypes.func.isRequired,
  actionCleanupDiscoveryProvinces: PropTypes.func.isRequired,

  categoriesLoading: PropTypes.bool.isRequired,
  categories: PropTypes.instanceOf(Array).isRequired,
  actionGetDiscoveryCategories: PropTypes.func.isRequired,
  actionCleanupDiscoveryCategories: PropTypes.func.isRequired,

  deleteLoading: PropTypes.bool.isRequired,
  actionDeleteDiscoverPlace: PropTypes.func.isRequired,
};

DiscoveryLocation.defaultProps = {};

const mapStateToProps = (state) => ({
  discoverPlaceList: state.DiscoverPlace.discoverPlaceList,
  discoverPlaceListLoading: state.DiscoverPlace.discoverPlaceListLoading,

  provincesLoading: state.DiscoverProvince.provincesLoading,
  provinces: state.DiscoverProvince.provinces,

  categoriesLoading: state.DiscoverCategory.categoriesLoading,
  categories: state.DiscoverCategory.categories,

  deleteLoading: state.DiscoverPlace.deleteLoading,
});

const mapDispatchToProps = ({
  actionGetDiscoverPlaceList: actionGetDiscoverPlaceListAction,
  actionCleanupDiscoverPlaceList: actionCleanupDiscoverPlaceListAction,

  // Discover Province
  actionGetDiscoveryProvinces: actionGetDiscoveryProvincesAction,
  actionCleanupDiscoveryProvinces: actionCleanupDiscoveryProvincesAction,

  // Discover Category
  actionGetDiscoveryCategories: actionGetDiscoveryCategoriesAction,
  actionCleanupDiscoveryCategories: actionCleanupDiscoveryCategoriesAction,

  actionDeleteDiscoverPlace: actionDeleteDiscoverPlaceAction,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscoveryLocation);
